import { LOGOUT } from 'constants/actions';
import { combineReducers } from '@reduxjs/toolkit';
import contactPreferences from './contactPreferences';
import user from './user';
import company from './company';
import integrations from './integrations';
import projects from './projects';
import photos from './photos';
import settings from './settings';
import users from './users';
import groups from './groups';
import remoteResources from './remoteResources';
import projectMap from './projectMap';
import userLocation from './userLocation';
import reports from './reports';
import todos from './todos';
import wizard from './wizard';

const appReducer = combineReducers({
  contactPreferences,
  user,
  projects,
  photos,
  company,
  integrations,
  settings,
  users,
  groups,
  remoteResources,
  projectMap,
  userLocation,
  reports,
  todos,
  wizard,
});

const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === LOGOUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
